import React, { useState } from 'react';
import { AnotacoesReembolsos } from './AnotacoesReembolsos';
import { GerenciadorAtas }     from './GerenciadorAtas';
import { Propostas }           from './Propostas';
import { Auditorias }          from './Auditorias';
import { useNamespaceEmpresa } from '../hooks/useNamespaceEmpresa';
import { useEmpresa } from '../contexts/EmpresaContext';

const EMPTY_ARR = Object.freeze([]);

const ABAS = [
  { id: 'anotacoes',  label: 'Anotações',  emoji: '📝' },
  { id: 'reembolsos', label: 'Reembolsos', emoji: '🔄' },
  { id: 'atas',       label: 'Atas',       emoji: '📋' },
  { id: 'propostas',  label: 'Propostas',  emoji: '📄' },
  { id: 'auditorias', label: 'Auditorias', emoji: '🔍' },
];

export const Documentos = ({
  anotacoes: anotacoesLegado, setAnotacoes: setAnotacoesLegado,
  anotacoesPorEmpresa, setAnotacoesPorEmpresa,
  reembolsos: reembolsosLegado, setReembolsos: setReembolsosLegado,
  reembolsosPorEmpresa, setReembolsosPorEmpresa,
  atas: atasLegado, setAtas: setAtasLegado,
  atasPorEmpresa, setAtasPorEmpresa,
  propostas: propostasLegado, setPropostas: setPropostasLegado,
  propostasPorEmpresa, setPropostasPorEmpresa,
  auditorias: auditoriasLegado, setAuditorias: setAuditoriasLegado,
  auditoriasPorEmpresa, setAuditoriasPorEmpresa,
  bancoClausulas: bancoClausulasLegado, setBancoClausulas: setBancoClausulasLegado,
  bancoClausulasPorEmpresa, setBancoClausulasPorEmpresa,
  notasDebito: notasDebitoLegado, setNotasDebito: setNotasDebitoLegado,
  notasDebitoPorEmpresa, setNotasDebitoPorEmpresa,
  clientes, profissionais,
  profissionalAtual, isAdmin,
}) => {
  const [aba, setAba] = useState('anotacoes');

  // Cada campo namespaced por empresa: Kzero Consultoria herda lazy o legado;
  // demais empresas começam vazias. Setter wrapper escreve em mapa[slug].
  const [anotacoes, setAnotacoes] = useNamespaceEmpresa({
    mapaPorEmpresa: anotacoesPorEmpresa, setMapaPorEmpresa: setAnotacoesPorEmpresa,
    legado: anotacoesLegado, setLegado: setAnotacoesLegado, vazio: EMPTY_ARR,
  });
  const [reembolsos, setReembolsos] = useNamespaceEmpresa({
    mapaPorEmpresa: reembolsosPorEmpresa, setMapaPorEmpresa: setReembolsosPorEmpresa,
    legado: reembolsosLegado, setLegado: setReembolsosLegado, vazio: EMPTY_ARR,
  });
  const [atas, setAtas] = useNamespaceEmpresa({
    mapaPorEmpresa: atasPorEmpresa, setMapaPorEmpresa: setAtasPorEmpresa,
    legado: atasLegado, setLegado: setAtasLegado, vazio: EMPTY_ARR,
  });
  const [propostas, setPropostas] = useNamespaceEmpresa({
    mapaPorEmpresa: propostasPorEmpresa, setMapaPorEmpresa: setPropostasPorEmpresa,
    legado: propostasLegado, setLegado: setPropostasLegado, vazio: EMPTY_ARR,
  });
  const [auditorias, setAuditorias] = useNamespaceEmpresa({
    mapaPorEmpresa: auditoriasPorEmpresa, setMapaPorEmpresa: setAuditoriasPorEmpresa,
    legado: auditoriasLegado, setLegado: setAuditoriasLegado, vazio: EMPTY_ARR,
  });
  const [bancoClausulas, setBancoClausulas] = useNamespaceEmpresa({
    mapaPorEmpresa: bancoClausulasPorEmpresa, setMapaPorEmpresa: setBancoClausulasPorEmpresa,
    legado: bancoClausulasLegado, setLegado: setBancoClausulasLegado, vazio: EMPTY_ARR,
  });
  // Bianca 31/07 (task 26 fix de raiz): notasDebito NÃO é mais namespaced por
  // empresa via mapa. Cada nota carrega seu próprio `empresaSlug` embutido, e
  // fica em `notasDebito` (flat). Permite salvamento por-item (evita overwrite
  // entre sessões — problema recorrente das 3 notas Sadel/Magna/Valge de junho
  // que ficaram invisíveis no histórico) e simplifica a numeração.
  // O `notasDebitoPorEmpresa` continua no schema pra retrocompat, mas não
  // recebe novos writes daqui.
  const { empresaAtiva } = useEmpresa();
  const empresaSlugAtual = empresaAtiva?.slug ?? 'kzero-consultoria';
  // Ignora silenciosamente notasDebitoPorEmpresa/setNotasDebitoPorEmpresa
  // (props mantidas pra retrocompat de assinatura).
  void notasDebitoPorEmpresa; void setNotasDebitoPorEmpresa;
  const notasDebito = notasDebitoLegado || EMPTY_ARR;
  const setNotasDebito = setNotasDebitoLegado;

  return (
    <div style={s.container}>
      {/* Cabeçalho */}
      <div style={s.header}>
        <h2 style={s.titulo}>Documentos</h2>
      </div>

      {/* Sub-abas */}
      <div style={s.abas}>
        {ABAS.map(a => (
          <button
            key={a.id}
            style={{ ...s.aba, ...(aba === a.id ? s.abaAtiva : {}) }}
            onClick={() => setAba(a.id)}
          >
            {a.emoji} {a.label}
          </button>
        ))}
      </div>

      {/* Conteúdo */}
      <div style={s.conteudo}>
        {aba === 'anotacoes' && (
          <AnotacoesReembolsos
            anotacoes={anotacoes} setAnotacoes={setAnotacoes}
            reembolsos={reembolsos} setReembolsos={setReembolsos}
            notasDebito={notasDebito} setNotasDebito={setNotasDebito}
            empresaSlugAtual={empresaSlugAtual}
            clientes={clientes} abaInicial="anotacoes" semTabs
            profissionalAtual={profissionalAtual} isAdmin={isAdmin}
          />
        )}
        {aba === 'reembolsos' && (
          <AnotacoesReembolsos
            anotacoes={anotacoes} setAnotacoes={setAnotacoes}
            reembolsos={reembolsos} setReembolsos={setReembolsos}
            notasDebito={notasDebito} setNotasDebito={setNotasDebito}
            empresaSlugAtual={empresaSlugAtual}
            clientes={clientes} abaInicial="reembolsos" semTabs
            profissionalAtual={profissionalAtual} isAdmin={isAdmin}
          />
        )}
        {aba === 'atas' && (
          <GerenciadorAtas
            atas={atas} setAtas={setAtas}
            clientes={clientes} profissionais={profissionais}
            profissionalAtual={profissionalAtual} isAdmin={isAdmin}
          />
        )}
        {aba === 'propostas' && (
          <Propostas
            propostas={propostas} setPropostas={setPropostas}
            clientes={clientes}
            profissionalAtual={profissionalAtual} isAdmin={isAdmin}
            bancoClausulas={bancoClausulas} setBancoClausulas={setBancoClausulas}
          />
        )}
        {aba === 'auditorias' && (
          <Auditorias
            auditorias={auditorias || []}
            setAuditorias={setAuditorias}
          />
        )}
      </div>
    </div>
  );
};

const s = {
  container: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
  header:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  titulo:    { fontSize: '1.8rem', fontWeight: 700, color: '#1c1530', margin: 0 },
  abas:      { display: 'flex', gap: '0.5rem', borderBottom: '2px solid #eeeaf5', paddingBottom: '0.75rem', flexWrap: 'wrap' },
  aba:       {
    background: 'transparent',
    border: '1px solid #e5e0ef',
    borderRadius: 20,
    color: '#5f5874',
    padding: '8px 20px',
    fontSize: 13,
    fontWeight: 500,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: 6,
  },
  abaAtiva: {
    background: '#7c3aed',
    borderColor: '#7c3aed',
    color: 'white',
    fontWeight: 600,
  },
  conteudo: {},
};
